const APPLICATION_NOTIFICATION_TYPES = [
  'application_received',
  'application_approved',
  'application_rejected',
  'application_message',
];

export const isApplicationNotificationType = (type) => APPLICATION_NOTIFICATION_TYPES.includes(type);

export const getNotificationTarget = (notif, role) => {
  const type = notif?.notification_type || notif?.type;
  const isDocumentType = ['document_uploaded', 'document_deleted', 'document_shared'].includes(type);

  if (notif?.thread_id && (role === 'tenant' || role === 'landlord')) {
    return {
      pathname: role === 'tenant' ? '/tenant' : '/landlord',
      hash: '#messages',
      state: { notificationThreadId: notif.thread_id },
    };
  }

  if (isDocumentType) {
    if ((role === 'landlord' || role === 'admin') && notif?.property_id) {
      const search = notif?.document_id ? `?documentId=${notif.document_id}` : '';
      return {
        pathname: `/property/${notif.property_id}/documents`,
        search,
      };
    }

    if (role === 'tenant') {
      const search = notif?.document_id ? `?documentId=${encodeURIComponent(notif.document_id)}` : '';
      return { pathname: '/tenant', search, hash: '#documents' };
    }
  }

  if (isApplicationNotificationType(type)) {
    const search = notif?.application_id ? `?applicationId=${encodeURIComponent(notif.application_id)}` : '';
    if (role === 'landlord') return { pathname: '/landlord', search, hash: '#applications' };
    if (role === 'tenant') return { pathname: '/tenant/explore', search, hash: '#applications' };
    if (role === 'admin') return { pathname: '/admin', search, hash: '#applications' };
  }

  if (type === 'screening_requested') {
    const search = notif?.application_id ? `?applicationId=${encodeURIComponent(notif.application_id)}` : '';
    if (role === 'tenant') return { pathname: '/tenant/explore', search, hash: '#applications' };
  }

  if (type === 'screening_completed') {
    const search = notif?.application_id ? `?applicationId=${encodeURIComponent(notif.application_id)}` : '';
    if (role === 'landlord') return { pathname: '/landlord', search, hash: '#applications' };
    if (role === 'admin') return { pathname: '/admin', search, hash: '#applications' };
  }

  if (type === 'property_saved') {
    if (role === 'landlord') return { pathname: '/landlord', hash: '#properties' };
    if (role === 'tenant') return { pathname: '/tenant/explore' };
    if (role === 'admin') return { pathname: '/admin', hash: '#properties' };
  }

  if (type === 'transfer_request') {
    if (role === 'landlord') return { pathname: '/landlord', hash: '#applications' };
    if (role === 'admin') return { pathname: '/admin', hash: '#assignments' };
    if (role === 'tenant') return { pathname: '/tenant', hash: '#overview' };
  }

  if ((type === 'issue_reported' || type === 'status_changed' || type === 'note_added') && notif?.issue_id) {
    const search = `?issueId=${encodeURIComponent(notif.issue_id)}`;
    if (role === 'tenant') return { pathname: '/tenant', search, hash: '#issues' };
    if (role === 'landlord') return { pathname: '/landlord', search, hash: '#issues' };
    if (role === 'admin') return { pathname: '/admin', search, hash: '#issues' };
  }

  if (type === 'landlord_message') {
    if (role === 'tenant') return { pathname: '/tenant', hash: '#messages' };
    if (role === 'landlord') return { pathname: '/landlord', hash: '#messages' };
  }

  if (type === 'user_registered' && role === 'admin') {
    return { pathname: '/admin', hash: '#users' };
  }

  if (role === 'tenant') return { pathname: '/tenant', hash: '#overview' };
  if (role === 'landlord') return { pathname: '/landlord', hash: '#overview' };
  if (role === 'admin') return { pathname: '/admin', hash: '#users' };
  return { pathname: '/' };
};
